<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Employer Profile</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Employer Profile</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="dashboard-area pt-100">
    <div class="row align-items-center">
        <div class="col-lg-4"></div>

        <div class="">
            <div class="dashboard-nav">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <!-- <li class="nav-item">
                        <a
                            class="nav-link active"
                            id="pills-home-tab"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-home"
                            aria-selected="true"
                            >My Profile</a
                        >
                    </li> -->

                    <!-- <li class="nav-item">
                        <a
                            class="nav-link"
                            id="pills-contact-tab"
                            data-toggle="pill"
                            routerLink="/employer/candidate-list"
                            role="tab"
                            aria-controls="pills-contact"
                            aria-selected="false"
                            >Candidate's List</a
                        >
                    </li> -->

                    <!-- <li class="nav-item">
                        <a
                            class="nav-link"
                            id="pills-contact-tab"
                            data-toggle="pill"
                            role="tab"
                            aria-controls="pills-contact"
                            aria-selected="false"
                            routerLink="/candidate/job-status"
                            >Job Status</a
                        >
                    </li> -->
                </ul>
            </div>
        </div>
    </div>

    <div class="container">
                  <div 
                                class="calendly-logo mb-4"
                                
                                (click)="openCalendly()"
                            >
                                <img
                                    src="../../../../assets/img/home-1/calendly.png"
                                    class="appointment rounded-circle"
                                />
                                <span class="booking">Book an appointment</span>
                            </div>
                        </div>

    <div class="container">
        <div class="create-information">
            <form [formGroup]="updateEmployerProfile">
                <h3>Personal Information</h3>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>First Name <span class="required">*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Aikin Ward"
                                formControlName="firstName"
                            />
                            <app-validation-error
                                [control]="
                                    updateEmployerProfile.get('firstName')
                                "
                            ></app-validation-error>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Middle Name</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Aikin Ward"
                                formControlName="middleName"
                            />
                            <app-validation-error
                                [control]="
                                    updateEmployerProfile.get('middleName')
                                "
                            ></app-validation-error>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>last Name <span class="required">*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Aikin Ward"
                                formControlName="lastName"
                            />
                            <app-validation-error
                                [control]="
                                    updateEmployerProfile.get('lastName')
                                "
                            ></app-validation-error>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Business Email <span class="required">*</span></label>
                            <input
                                [disabled]="isEmailDisabled"
                                type="email"
                                class="form-control"
                                placeholder="Johndoe@gmail.com"
                                formControlName="email"
                            />
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label> Business Name <span class="required">*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Acme Corporation"
                                formControlName="businessName"
                            />
                            <app-validation-error
                                [control]="
                                    updateEmployerProfile.get('businessName')
                                "
                            ></app-validation-error>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Contact Number <span class="required">*</span></label>
                            <div class="input-group mb-3">
                                <!-- <span class="input-group-text">{{
                                    this.countryCode
                                }}</span> -->
                                <input
                                type="text"
                                class="form-control"
                                placeholder="0255504321"
                                formControlName="phoneNumber"
                            />
                                <!-- <input
                                    type="text"
                                    class="form-control"
                                    placeholder="0255504321"
                                    formControlName="phoneNumber"
                                    (ngModelChange)="
                                        onChangePhoneNumber($event)
                                    "
                                /> -->
                            </div>
                            <app-validation-error
                                [control]="
                                    updateEmployerProfile.get('phoneNumber')
                                "
                            ></app-validation-error>
                        </div>
                    </div>

                    <!-- <div class="col-lg-4">
                        <div class="form-group">
                            <label>College Name</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Aikin Ward"
                                formControlName="collegeName"
                            />
                            <app-validation-error
                                [control]="
                                    updateEmployerProfile.get('collegeName')
                                "
                            ></app-validation-error>
                        </div>
                    </div> -->

                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Company Address</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="210-27 Quadra, Market Street, Victoria Canada"
                                formControlName="collegeAddress"
                            />
                            <!-- <app-validation-error
                                [control]="
                                    updateEmployerProfile.get('collegeAddress')
                                "
                            ></app-validation-error> -->
                        </div>
                    </div>

                    <!-- <div class="col-lg-6">
                        <label class="select_label">Country</label>
                        <div class="form-group">
                            <ngx-select-dropdown
                                [config]="config"
                                [options]="country_list"
                                formControlName="country"
                            >
                            </ngx-select-dropdown>
                        </div>
                        <app-validation-error
                            [control]="updateEmployerProfile.get('country')"
                        ></app-validation-error>
                    </div> -->
                </div>
            </form>
        </div>
        <div class="text-left">
            <button type="submit" (click)="submit()" class="btn create-ac-btn">
                <span>Save</span>
                <small
                    class="loadingspinner d-inline-block ms-2"
                    *ngIf="loader"
                ></small>
            </button>
        </div>
    </div>

    <div class="container mt-5">
        <div class="create-information">
            <form [formGroup]="lookingFor">
                <h3>Looking for?</h3>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Categories</label>
                            <div class="form-group mt-2">
                                <ngx-select-dropdown
                                    [config]="configCategory"
                                    [options]="jobCategory"
                                    [multiple]="true"
                                    formControlName="category"
                                    (change)="onSelectCategory($event)"
                                ></ngx-select-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Looking For?</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="What are you looking for?"
                                formControlName="questionText"
                            />
                            <app-validation-error
                                [control]="
                                    lookingFor.get('questionText')
                                "
                            ></app-validation-error>
                        </div>
                    </div>
                
                
                </div>
            </form>
        </div>
        <div class="text-left">
            <button  (click)="submitLookingFor()" class="btn create-ac-btn">
                <span>Save</span>
                <small
                class="loadingspinner d-inline-block ms-2"
                *ngIf="lookingForLoader"
            ></small>
            </button>
        </div>
    </div>
</div>
